module.exports = __webpack_public_path__ + "static/media/blankpf.9acfe78b.png";